// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n.list-container[data-v-31c8e3d0] {\n  width: 100%;\n}\n.list-container .toolbar[data-v-31c8e3d0] {\n  width: 100%;\n  height: 50px;\n}\n[data-v-31c8e3d0] .error-row td {\n  color: red;\n  /* 设置文字颜色为红色 */\n}", ""]);
// Exports
module.exports = exports;
